(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("ppt", [], factory);
	else if(typeof exports === 'object')
		exports["ppt"] = factory();
	else
		root["ppt"] = factory();
})((typeof self !== 'undefined' ? self : this), function() {
return 